export enum TextBoxTheme {
  White = 'white',
  Transparent = 'transparent',
  Orange = 'orange',
}
